module.exports = __webpack_public_path__ + "static/media/phones.73abc0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/phones.png
// module id = 345
// module chunks = 0